import { useCallback } from "react";

interface ModalSizing {
  height: string;
  width: string;
  maxHeight: string;
  minWidth: string;
}

export const useGetModalSizing = (
  hasImage: boolean,
  isMobile: boolean,
  height?: string,
  width?: string
): ModalSizing => {
  const getModalWidthValues = useCallback(() => {
    let modalWidthValues;
    if (isMobile) {
      modalWidthValues = { width: "100%", minWidth: "100%" };
    } else if (width) {
      modalWidthValues = { width, minWidth: width };
    } else {
      modalWidthValues = hasImage
        ? { width: "50%", minWidth: "810px" }
        : { width: "30%", minWidth: "383px" };
    }
    return modalWidthValues;
  }, [hasImage, isMobile, width]);

  const getModalHeightValues = useCallback(() => {
    let modalHeightValues;
    if (isMobile) {
      modalHeightValues = { height: "100%", maxHeight: "100vh" };
    } else if (height) {
      modalHeightValues = { height, maxHeight: height };
    } else {
      modalHeightValues = {
        height: "min-content",
        maxHeight: "80%",
      };
    }
    return modalHeightValues;
  }, [isMobile, height]);

  return {
    ...getModalWidthValues(),
    ...getModalHeightValues(),
  };
};
